export default __webpack_public_path__ + "static/development-ea89e08d9417837b8b7e74f91636ced3.jpg";